import React, {useState, useContext} from 'react';
import {ModalBody, ModalHeader, Spinner} from 'reactstrap';
import {Router} from 'react-router-dom';
import history from '../../routes/history';
import {ModalContext, ThemeContext} from '../../apiContexts';
import {ModalXD} from '../../styles';
import {modalList, modalDetail} from '../../views/modals/modalList';
import I18nMessage from '../../components/I18nMessage';
import ModalEnum from '../../views/modals/modalEnum';
import {consumeEscapeHandled} from '../../helpers/escapeGuard';

const ModalContainer = ({children, ...props}) => {
  const theme = useContext(ThemeContext);
  const [modalInfo, setModalInfo] = useState({title: 'sharedTitle', type: ''});
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const openModal = (modal) => {
    setModalInfo(modalDetail[modal]);
    setModal(true);
  };

  // Todo fechamento passa por aqui (botão do cabeçalho, fundo, Esc e o toggle do contexto). O jobId que
  // o sino põe no estado da navegação só vale enquanto Relatórios Solicitados está aberto; sem tirá-lo,
  // reabrir a tela pelo menu realçaria o pedido antigo. A query e o hash ficam como estão: são do mapa.
  const toggle = (event) => {
    if (event?.type === 'keyup' && consumeEscapeHandled()) {
      return;
    }
    if (modal && modalInfo.type === ModalEnum.REPORT_JOBS) {
      const {pathname, search, hash, state} = history.location;
      if (state && state.jobId !== undefined) {
        const {jobId, ...rest} = state;
        history.replace({pathname, search, hash, state: rest});
      }
    }
    setModal(!modal);
  };

  const showModalLoading = (value) => setLoading(value);

  return (
    <ModalContext.Provider value={{openModal, toggle, showModalLoading, isModalLoading: loading}}>
      <>
        {children}

        <ModalXD
          size="lg"
          centered
          isOpen={modal}
          toggle={toggle}
          theme={theme}
          unmountOnClose={true}
        >
          <ModalHeader toggle={toggle}>
            {loading && <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              className={'spinner-modal'}
              aria-hidden="true"
            /> }
            <I18nMessage id={modalInfo.title}/>
          </ModalHeader>
          <ModalBody>
            {/* O modal fica fora do Router das rotas; sem este, tela do modal que usa hook ou Link do
                react-router quebra. O history e o mesmo singleton das rotas. */}
            <Router history={history}>
              {
                {
                  ...modalList,
                }[modalInfo.type]
              }
            </Router>
          </ModalBody>
        </ModalXD>
      </>
    </ModalContext.Provider>
  );
};

export default ModalContainer;
